import { Page } from "@/models/page-models/Page";

export const CustomerSalesVariance: Page = {
  "path": "customer-sales-variance",
  "name": "Customer Sales Variance",
  "props": {
    "data": {
      "title": "Customer Sales Variance",
      "printable": "FALSE",
      "url": "customer-sales-variance",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesVarianceForm.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesVarianceForm.customer",
                  "label": "Select Customer",
                  "disabled": "fn(NOT,{{fetchedData.salesVarianceForm.year}})",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetVarianceData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.salesVarianceData"
                      },
                      "name": "resetVarianceData"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesVarianceForm.displaySAR",
                  "label": "Data Type",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Quantity\",\"value\":false},{\"text\":\"SAR\",\"value\":true}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetVarianceData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.salesVarianceData"
                      },
                      "name": "resetVarianceData"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Customer Variance",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToCustomerSalesVariance",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/customer-sales-variance",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{fetchedData.salesVarianceForm.customer}}\",\"year\":\"{{fetchedData.salesVarianceForm.year}}\",\"displaySAR\":\"{{fetchedData.salesVarianceForm.displaySAR}}\"}"
                      },
                      "name": "redirectToCustomerSalesVariance"
                    }
                  ],
                  "disabled": "fn(NOT,{{fetchedData.salesVarianceForm.customer}})",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesVariance",
                  "showIf": "{{fetchedData.salesVarianceData.data}}",
                  "varianceDataVariable": "fetchedData.salesVarianceData.data",
                  "mode": "product",
                  "displaySarVariable": "fetchedData.salesVarianceForm.displaySAR"
                }
              ],
              "showIf": "{{fetchedData.salesVarianceData.data}}",
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.salesVarianceData.data.status}},'),==,'Approved')"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultSalesVarianceForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSalesVarianceForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.salesVarianceForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultSalesVarianceForm"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "loadSalesVarianceData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-forecast/customer-sales-variance",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.salesVarianceData",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.salesVarianceForm"
        },
        "name": "loadSalesVarianceData",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesVarianceForm.customer}},>,0)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultSalesVarianceForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "fn(NUMBER,{{__query.customer}})",
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})",
          "displaySAR": "fn(CONDITIONAL,fn(LOGICAL,{{__query.displaySAR}},==,false),{{__query.displaySAR}},true)"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Closed Customer", "Open Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}